import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Divider, Grid, Typography } from '@mui/material';
import BenefitDetailCard from './BenefitDetailCard';
import ReusableComparisonTable from './ReusableComparisonTable';
import FYDetailsSection from './FYDetailsSection';
import { useLocation, useNavigate } from 'react-router-dom';
import { GAPDetailAction } from '../APIs/action';
import { toast } from 'react-toastify';


const GAPDetailPage = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const selectedManufacturer = location.state?.selectedManufacturer;
	const selectedCompanyEntity = location.state?.selectedCompanyEntity;

	const [gapDetail, setGapDetail] = useState([]);
	const [loader, setLoader] = useState(false);


	const getGAPDetail = async (selectedManufacturer, selectedCompanyEntity) => {
		setLoader(true);
		const { data, message, error } = await GAPDetailAction(selectedManufacturer, selectedCompanyEntity);
		setLoader(false);
		if (!error) {
			setGapDetail(data);
		} else {
			toast.error(message);
		}
	};
	useEffect(()=>{
		if(selectedManufacturer && selectedCompanyEntity){
			getGAPDetail(selectedManufacturer, selectedCompanyEntity);
		}else{
			navigate('/benefits/mybenefits', { replace: true });
		}
	},[ selectedManufacturer, selectedCompanyEntity])
	if (loader) {
		return (
			<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
				<CircularProgress/>
			</Box>
		);
	}

	const benefitDetails = gapDetail?.benefit_card || {};
	const gapDisbursed = gapDetail?.gap_disbursed || null;
	const fyDetails = gapDetail?.fy_details || [];
	const note = gapDetail?.note;
	
	return (
		<Box sx={{ p: { xs: 2, md: 3 } }}>
			<Grid container spacing={{ xs: 2, md: 3 }} sx={{ mb: 2 }}>
				<Grid item xs={12} md={6}>
				<Box
					sx={{
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
					p: 2,
					background: '#ffffff',
					border: '1px solid #D9D9D9',
					borderRadius: 2,
					}}
				>
					<BenefitDetailCard benefitDetails={benefitDetails} spacing={false} note={note} />
				</Box>
				</Grid>
					{gapDisbursed && (
						<Grid item xs={12} md={6}>
							<ReusableComparisonTable
								title="GAP Disbursed to date"
								tableInfo={gapDisbursed}
								headerVariant="labelD"
								footerVariant="body1"
								cellVariant="body1"
							/>
						</Grid>
					)}
				<Divider sx={{ my: 3 }} />
				{fyDetails && (
					<Grid item xs={12}>
						<Box sx={{ border: '1px solid #D9D9D9', borderRadius: 2, p: 2, backgroundColor: '#ffffff' }}>
							<Typography variant="h2" sx={{ mb: 2 }}>
								Gross GAP accumulated for the financial year
							</Typography>
							<FYDetailsSection fyDetails={fyDetails} note={note} />
						</Box>
					</Grid>
				)}
				
			</Grid>
		</Box>
  	);
};

export default GAPDetailPage;
